import Home from "screens/public/index-config";
export default Home;
